import { VBox } from "../box/Box";
import Spacer from "../spacer/Spacer";
import { Typo } from "../text/Typo";
import { Spinner } from "./Spinner";

export const SpinnerProgress = ({
	busy,
	size,
}: {
	busy: boolean;
	size?: number;
}) => {
	if (!busy) return null;
	return (
		<VBox center sx={{ flexGrow: "1" }}>
			<Spacer size="20px" />
			<Spinner size={size ?? 20} />
			<Spacer size="10px" />
			<Typo variant="caption">LOADING...</Typo>
			<Spacer size="20px" />
		</VBox>
	);
};
